<template>
  <v-col 
    xs="10"
    sm="8"
    md="5"
    lg="4"
  >
    <h2>Mot de passe oublié</h2>
    <form>

      <v-text-field
        v-model="email"
        :error-messages="emailErrors"
        label="Adresse e-mail"
        required
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
        @keyup.enter="submit"
      ></v-text-field>

      <v-btn 
        class="mr-4 success float-right" 
        @click="submit"
      >
        <v-icon 
          class="mr-2"
          style="font-size: 13px;"
        >
          mdi-send
        </v-icon>
        Envoyer
      </v-btn>

      <span class="red-text">{{ errors }}</span>
    </form>
  </v-col>
</template>

<script>
  // LIBRARY
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { AUTH_RESET_PSWD } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'

  export default {
    name: 'CheckEmail',

    mixins: [validationMixin],

    data: () => ({
      email: '',
      password: '',
      dialog: false,
      errors: '',
      emailSent: false,
    }),

    validations: {
      email: { required, email },
    },

    methods: {
      submit () {
        this.errors = ''
        this.dialog      = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = ''
        } else {
          this.send()
        }
      },
      send() {
        EventBus.$emit(LOADING, 'Envoi en cours...')
        const { email } = this
        this.$store.dispatch(AUTH_RESET_PSWD, { email }).then(() => {
          EventBus.$emit(LOADED)
          this.$router.push({
            name: 'ResettingEmailSent',
            params: {
              email: this.encryptEmail
            }
          })
        }).catch(error => {
          if (error.response) {
            this.errors = error.response.data.error
          } else if (error.request) {
            this.errors = error.request
          } else {
            this.errors = error.message
          }
          EventBus.$emit(LOADED)
        })
      }
    },

    computed: {
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Adresse email incorrecte')
        !this.$v.email.required && errors.push('Veuillez renseigner une adresse email')
        return errors
      },
      encryptEmail() {
        return `${this.email.charAt(0)}...@${this.email.split('@')[1]}`
      }
    },

    mounted() {
      EventBus.$emit(LOADED)
    }
  }
</script>

<style scoped>
  .red-text {
    color: red;
  }
</style>